module.exports = __webpack_public_path__ + "assets/6c7b00135fa4b4316bf062268c2cc4a8.jpg";